// src/services/notificationService.ts

import { supabase } from '../../supabase';

export const createNotification = async (
  userId: string,
  title: string,
  body: string
) => {
  console.log('createNotification: Starting');
  console.log('createNotification: Inputs:', { userId, title, body });

  const { data, error } = await supabase
    .from('notifications')
    .insert({ user_id: userId, title, body })
    .select()
    .single();

  console.log('createNotification: Supabase result:', { data, error });

  if (error) {
    console.error('createNotification: Error:', error);
    return null;
  }

  console.log('createNotification: Successful');
  return data;
};

export const getUserNotifications = async (userId: string) => {
  const { data, error } = await supabase
    .from('notifications')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching notifications:', error);
    return [];
  }

  return data;
};

export const markNotificationAsRead = async (notificationId: number) => {
  const { error } = await supabase
    .from('notifications')
    .update({ read: true })
    .eq('id', notificationId);

  if (error) {
    console.error('Error marking notification as read:', error);
  }
};

export const sendNotification = async (
  type: string,
  recipients: string[],
  title: string,
  body: string,
  additionalData: object = {}
) => {
  console.log('sendNotification: Starting');
  console.log('sendNotification: Inputs:', {
    type,
    recipients,
    title,
    body,
    additionalData,
  });

  const { data, error } = await supabase.functions.invoke(
    'send-push-notifications',
    {
      body: JSON.stringify({
        type,
        recipients,
        data: {
          title,
          body,
          ...additionalData,
        },
      }),
    }
  );

  if (error) {
    console.error('sendNotification: Error sending notification:', error);
    throw error;
  }

  console.log('sendNotification: Notification sent successfully:', data);
  return data;
};

export const getUserPushToken = async (
  userId: string
): Promise<string | null> => {
  const { data, error } = await supabase
    .from('askers')
    .select('auth_id')
    .eq('id', userId)
    .single();

  if (error) {
    console.error('Error fetching user push token:', error);
    return null;
  }

  return data?.auth_id || null;
};

export const sendPushNotification = async (
  userId: string,
  title: string,
  body: string,
  additionalData: object = {}
) => {
  try {
    console.log('sendPushNotification: Starting');
    console.log('sendPushNotification: Inputs:', {
      userId,
      title,
      body,
      additionalData,
    });

    const data = await sendNotification(
      'general_notification',
      [userId],
      title,
      body,
      additionalData
    );

    console.log('sendPushNotification: Notification sent successfully:', data);
  } catch (error) {
    console.error('sendPushNotification: Error sending notification:', error);
  }
};
